import { render, staticRenderFns } from "./AdvancedAnalytics.vue?vue&type=template&id=a0527bea&scoped=true&"
import script from "./AdvancedAnalytics.vue?vue&type=script&lang=js&"
export * from "./AdvancedAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedAnalytics.vue?vue&type=style&index=0&id=a0527bea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0527bea",
  null
  
)

export default component.exports